import { SORT_DIRECTIONS } from 'app/shared/componentsRestyled/common/TooltipedSortLabel/TooltipedSortLabel.constants';
import _ from 'lodash';

export const TableCellId = {
  TITLE: 'title',
  START_DATE: 'startDate',
  EXPIRES_IN_DAYS: 'expiresInDays',
  EXPIRATION_DATE: 'expirationDate',
  ACTION: 'action',
};

export const defaultOrder = {
  id: TableCellId.TITLE,
  direction: SORT_DIRECTIONS.ASC,
};

export const tableCellWidthMap = {
  [TableCellId.TITLE]: '30%',
  [TableCellId.START_DATE]: '20%',
  [TableCellId.EXPIRES_IN_DAYS]: '15%',
  [TableCellId.EXPIRATION_DATE]: '20%',
  [TableCellId.ACTION]: '15%',
};

export const newRecordInitialValues = {
  [TableCellId.TITLE]: '',
  [TableCellId.START_DATE]: '',
  [TableCellId.EXPIRES_IN_DAYS]: '',
  [TableCellId.EXPIRATION_DATE]: '',
};

export const cellsCount = _.size(TableCellId);
export const tableCellDateTypes = [TableCellId.START_DATE, TableCellId.EXPIRATION_DATE];
export const tableCellNumberTypes = [TableCellId.EXPIRES_IN_DAYS];
